import { Component } from '@angular/core';

@Component({
    selector: 'app-breadcrumb-user-profile',
    templateUrl: './breadcrumb.user.profile.component.html'
})

export class BreadcrumbUserProfileComponent { }
